module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAARpJREFUWAntmEsOwjAMRFvEKWDDGm4D54TbwLobuEb5SCNZqZk4ripC5G6SemzHfk4lRNfFEwSCACXQa+rufB81+1zbcNqq57G8KybWoK1ZEZ6OtXxzJlI9wShQG3mJjd5BmUi7R7ijTJM5PHtzgZ7kaYzWSOqDpmE3F5gGIsF7ZZr08+zNBXqSpzGskW904ytOKZa+m0esjQAjY5pWEPwRr/nAVv2IzQRZt0wDCe/aDkEvAS2uhHg7BPHlSSIgwTTpjz38EQ+7trZDkHXLNI1Kia0dgiVd53xLiFdPMArMjTunB8EcoZxePcHJnzm7y+PajeP+01nf33IdmnTkszi/zhyOmwNcp78HZTK5R8TS6y/OXLqnyP/XBJ5nZEtF5RMzUAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/login_icon_company.png
// module id = 868
// module chunks = 130